import { pageview } from 'vue-gtag'

function getAfterEachRouteGuards(router) {
  const gTagPageViewRouteGuard = (to: Route) => {
    const { gtagId } = useSessionData()
    if (gtagId && to.meta?.page_view)
      pageview(to.path)
  }

  const closeMobileMenuGuard = () => {
    const { isOpen } = useAppNavMenuMobileState()
    if (isOpen.value)
      isOpen.value = false
  }

  return [
    gTagPageViewRouteGuard,
    closeMobileMenuGuard,
  ]
}

export default getAfterEachRouteGuards
